import React from "react";

export default function SubscriptionTrialModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="bg-teal-100 rounded-full p-2">
            <svg
              className="w-5 h-5 text-teal-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
              />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-gray-800">
            Your 30-day free trial has started
          </h2>
        </div>

        <p className="text-sm text-gray-600 leading-relaxed">
          You have full access to all MedMaze provider features for the next 30
          days — no credit card required.
        </p>
        <p className="text-sm text-gray-600 leading-relaxed">
          After your trial ends, a subscription of{" "}
          <span className="font-semibold text-gray-800">$50/month</span> keeps
          your full access active. You can subscribe anytime from the Billing
          tab in your dashboard.
        </p>

        <button
          onClick={onClose}
          className="w-full bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium py-2.5 rounded-lg transition"
        >
          Got it, let's go
        </button>
      </div>
    </div>
  );
}
